import './StudentAgentAnswer.scss';

export function StudentAgentAnswer({ aiquestion }) {
  const {
    weight,
    ai_student_answered_option: answerOption,
    ai_student_answered_text: answerText,
    ai_student_source_paragraph: sourceParagraph,
  } = aiquestion;

  if (answerOption?.length > 0) {
    return (
      <>
        {weight > 0 && (
          <div className="alert-success student-agent-box text">
            <p>Answered correctly</p>
            {answerText && (
              <>
                <hr className="green-line" />
                <p>Source paragraph:</p>
                <p>{sourceParagraph}</p>
              </>
            )}
          </div>
        )}
        {weight === 0 && (
          <div className="alert-warning student-agent-box text">
            <p>Answered incorrectly</p>
            {answerText && sourceParagraph && (
              <>
                <hr className="yellow-line" />
                <p>Answer:</p>
                <p>{answerText}</p>
                <p>Source paragraph:</p>
                <p>{sourceParagraph}</p>
              </>
            )}
          </div>
        )}
        {weight < 0 && (
          <div className="alert-danger student-agent-box text">
            <p>Couldn&apos;t be answered</p>
            {sourceParagraph && (
              <>
                <hr className="red-line" />
                <p>Source paragraph:</p>
                <p>{sourceParagraph}</p>
              </>
            )}
          </div>
        )}
      </>
    );
  }
  return <></>;
}
